var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OneCompetence',{attrs:{"showCompentence":_vm.showCompentence},on:{"close":function($event){_vm.showCompentence = false}}}),_c('div',{staticClass:"p-2"},[_c('ve-table',{attrs:{"columns":_vm.columns,"table-data":_vm.tableData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }